import React from "react";

const config = {
  ROMS: {
    montgri: {
      name: "Montgri Adventures",
      description: <span>This is my own homebrew NES rom</span>,
      url: "https://jespicas.bitbucket.io/roms/montgriadventures/cart.nes"
    },
    level3: {
      name: "Montgri Adventures Level3",
      description: <span>This is level 3 for OKR</span>,
      url: "https://jespicas.bitbucket.io/roms/level3/cart.nes"
    }
  },
  GOOGLE_ANALYTICS_CODE: process.env.REACT_APP_GOOGLE_ANALYTICS_CODE,
  SENTRY_URI: process.env.REACT_APP_SENTRY_URI
};

export default config;
